<template> 
  <modal name="shipment-pickup-date" height="auto" @opened="onOpened" @before-open="beforeOpen">
    <div class="col-sm-12" style="display:inline-block;">
      <div class="form-group">
        <h4 class="card-title">Pick Up Date and Time</h4>
      </div>


      <input id="pickupdate" type="text" v-model="pickupDate" class="form-control pickup-datetimepicker" name="pickupdate" data-vv-as="pickup date" v-validate="'required|validDate'">
      <div style="display:inline-block; height: 300px;"></div>

      <div class="row">
        <div class="col-sm-6">
          <p v-show="errors.has('pickupdate')" class="help is-danger">{{ errors.first('pickupdate') }}</p>
          <p v-show="serverError" class="help is-danger">{{ serverError }}</p>
        </div>
        <div class="col-sm-6">
          <div class="form-group form-actions">
            <button class="btn btn-success btn-wd float-right" style="margin-bottom: 16px" :disabled="submiting" @click="setDate"><i class="fa fa-save"></i> Save</button>
          </div>
        </div>

      </div>
    </div>


  </modal>
</template>

<script>
import "../../static/js/bootstrap-datetimepicker.js"
import apiService from '../services/api.service'

export default {
  name: 'ShipmentPickUpDateModal',
  data: function () {
    return {
      rfqId: "",
      pickupDate: "",
      serverError: "",
      submiting: false
    }
  },
  computed: {
    pickupDateTime() {
      return newSafeDate(this.pickupDate);
    }
  },
  methods: {
    onOpened() {
      initDatePickers('.pickup-datetimepicker');
    },
    beforeOpen(event) {
      this.rfqId = event.params.rfqId;
      this.pickupDate = "";
      this.serverError = "";
    },
    async setDate() {
      this.submiting = true;
      this.serverError = ""

      await this.$validator.validateAll();
      if (this.errors.any()){
        this.submiting = false;
        return;
      };

      try {
        const resp = await apiService.put(`/shipment/setPickupDate/${this.rfqId}`, {
          pickupTime: this.pickupDateTime.getTime()
        });

        this.$parent.$emit('pickupDateSet', { date: this.pickupDateTime });
        this.$modal.hide("shipment-pickup-date");
      } catch (error) {
        this.serverError = "Failed to set pickup date."
      }

      this.submiting = false;
    }
  }
}
</script>


// WEBPACK FOOTER //
// ShipmentPickUpDateModal.vue?afd42808